import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DxDataGridComponent, DxSelectBoxComponent } from 'devextreme-angular';
import notify from 'devextreme/ui/notify';
import { moduli } from '../../config';
import { StrojeviService } from './strojevi.service';

@Component({
  selector: 'app-strojevi',
  templateUrl: './strojevi.component.html',
  styleUrls: ['./strojevi.component.scss'],
  providers: [StrojeviService],
})
export class StrojeviComponent implements OnInit {
  @ViewChild(DxDataGridComponent, { static: false })
  dataGrid: DxDataGridComponent;
  @ViewChild('selectBox', { static: false })
  selectBox: DxSelectBoxComponent;

  sviStrojevi: any;
  sviProcesi: any;
  odabraniStroj: any;
  odabraniProces: any;
  sveLinije: any;
  odabranaLinija: any;
  procesi = [];
  oznacenRed: number;
  aktivan: number;
  linijeDohvacene = false;
  linijeDohvacenePoruka = 'Učitavanje linija...';
  procesiLookup: any;

  // PRAVA KORISNIKA
  pravaKorisnika = JSON.parse(sessionStorage.getItem('pravakorisnika'));
  trenutniPogled: any;
  pravaZaTrenutniPogled: any;
  prikaziStranicu = 0;
  // KRAJ PRAVA KORISNIKA

  constructor(private service: StrojeviService, private router: Router) {
    if (parseInt(localStorage.getItem('firma')) == 3) {
      this.router.navigate(['/dostavnica-hlad']);
    }

    // PRAVA KORISNIKA
    this.trenutniPogled = moduli().linijaStrojevi;
    for (var i = 0; i < this.pravaKorisnika.length; i++) {
      //console.log(i);
      if (this.pravaKorisnika[i].smo_ime == this.trenutniPogled) {
        this.pravaZaTrenutniPogled = this.pravaKorisnika[i].sgm_prava;
        //console.log(this.pravaZaTrenutniPogled);
        if (this.pravaKorisnika[i].sgm_prava != 0) {
          this.prikaziStranicu = 1;
        } else {
          notify('Nemate prava.', 'error', 3000);
        }
        return;
      } else {
      }
    }
    // KRAJ PRAVA KORISNIKA
  }

  ngOnInit() {
    this.dohvatiSveStrojeve();
    this.dohvatiSveLinije();
    this.dohvatiSveProcese();
  }

  oznaciProces(data) {
    // console.log(data);
    this.oznacenRed = data.rowIndex;
    this.aktivan = data.data.aktivan ? 0 : 1;
    this.dataGrid.instance.cellValue(this.oznacenRed, 'aktivan', this.aktivan);
  }

  spremiPromjene(e) {
    console.log(e);
    let onSaveObject = {
      idprocesistroj: e.data.id,
      idstroj: e.data.idStroj,
      aktivan: e.data.aktivan,
      amortizacija: e.data.amortizacija,
      potrosnjastrujenastroju: e.data.potrosnjaStruje,
      strujastroj: e.data.struja,
      potrosnjaplina: e.data.potrosnjaPlina,
      plinstroj: e.data.plin,
      potrosnjavode: e.data.potrosnjaVode,
      vodastroj: e.data.voda,
      ulaznafaktura: e.data.ulaznaFaktura,
      idproces: e.data.idProces,
    };
    console.log(onSaveObject);
    this.service.urediStroj(onSaveObject).subscribe((res) => {
      console.log(res);
      if (res.success === true) {
        this.dohvatiStrojeve(this.odabranaLinija);
        notify('Uspješno uređivanje podataka!', 'success', 3000);
      } else {
        notify(
          'Došlo je do greške na serveru, pokušajte ponovno!',
          'error',
          3000
        );
      }
    });
  }

  dohvatiStrojeve(linija) {
    this.service.dohvatiSveStrojeve({ idlinija: linija }).subscribe((res) => {
      console.log(res);
      this.procesi = [];
      for (let proces of res.data) {
        this.procesi.push({
          id: proces.idprocesistroj,
          idStroj: proces.stroj_idstroj,
          naziv: proces.st_naziv,
          sifra: proces.st_sifra,
          sifraNaziv: proces.st_sifra + ' ' + proces.st_naziv,
          aktivan: proces.pis_aktivan,
          amortizacija: proces.pis_amortizacija,
          potrosnjaStruje: proces.pis_potrosnjastrujenastroju,
          struja: proces.pis_strujastroj,
          potrosnjaPlina: proces.pis_potrosnjaplina,
          plin: proces.pis_plinstroj,
          potrosnjaVode: proces.pis_potrosnjavode,
          voda: proces.pis_vodastroj,
          ulaznaFaktura: proces.pis_ulaznafaktura,
          idProces: proces.proces_idproces,
          nazivProcesa:
            proces.ps_naziv === null ? 'NIJE POVEZANO' : proces.ps_naziv,
        });
      }
      console.log(this.procesi);
    });
  }

  dohvatiSveStrojeve() {
    this.service.dohvatiSveStojeve({}).subscribe((res) => {
      console.log(res);
      this.sviStrojevi = [];
      for (let data of res.data) {
        this.sviStrojevi.push({
          id: data.idstroj,
          sifra: data.st_sifra,
          naziv: data.st_naziv,
          sifraNaziv: data.st_sifra + ' ' + data.st_naziv,
        });
      }
    });
  }

  dohvatiSveLinije() {
    this.service.dohvatiSveLinije({}).subscribe((res) => {
      console.log(res);
      this.sveLinije = [];
      if (res.success === true) {
        for (let data of res.data) {
          this.sveLinije.push({
            id: data.idlinija,
            naziv: data.li_naziv,
          });
        }
        this.linijeDohvacene = true;
      } else {
        this.linijeDohvacene = false;
        this.linijeDohvacenePoruka =
          'Neuspješno dohvaćanje linija, pokušajte ponovno!';
      }
    });
  }

  dohvatiSveProcese() {
    this.service.dohvatiSveProcese({}).subscribe((res) => {
      console.log(res);
      this.sviProcesi = [];
      this.procesiLookup = [];
      if (res.success === true) {
        for (let data of res.data) {
          this.sviProcesi.push({
            id: data.idproces,
            naziv: data.ps_naziv,
          });
        }
        this.procesiLookup = [...this.sviProcesi];
        console.log(this.procesiLookup);
      }
    });
  }

  odaberiLiniju(e) {
    console.log(e);
    this.odabranaLinija = e.value;
    if (this.odabranaLinija) {
      this.dohvatiStrojeve(this.odabranaLinija);
    }
    if (this.odabraniStroj) {
      this.selectBox.instance.reset();
    }
  }

  odaberiProces(e) {
    console.log(e);
    this.odabraniProces = e.value;
    if (this.odabraniStroj) {
      this.selectBox.instance.reset();
    }
  }

  odaberiStroj(e) {
    console.log(e);
    this.odabraniStroj = e.value;
    if (this.odabraniStroj) {
      this.service
        .kreirajStroj({
          idlinija: this.odabranaLinija,
          idstroj: this.odabraniStroj,
          idproces: this.odabraniProces,
        })
        .subscribe((res) => {
          console.log(res);
          if (res.success === true) {
            this.dohvatiStrojeve(this.odabranaLinija);
            if (Array.isArray(res.data)) {
              notify('Stroj je već pridružen liniji!', 'warning', 3000);
            } else {
              notify('Stroj je uspješno pridružen liniji!', 'success', 3000);
            }
          }
        });
    }
  }

  obrisiStrojSaLinije(data) {
    console.log(data);
    this.service
      .obrisiStroj({
        idprocesistroj: data.data.id,
      })
      .subscribe((res) => {
        console.log(res);
        if (res.success === true) {
          this.dohvatiStrojeve(this.odabranaLinija);
          notify('Stroj je uspješno obrisan sa linije!', 'success', 3000);
        }
      });
  }
}
